<template>
  <div>
    <div class="d-flex custom-gap position-relative">
      <atom-custom-avatar
        :avatar-icon="avatarIcon"
        :avatar-variant="avatarVariant"
        class="flex-shrink-0"
      ></atom-custom-avatar>
      <div class="pr-4 text-break">
        <span v-if="isPrimary" class="d-block font-size-10 text-uppercase">
          Primary {{ contactTypeFormat }}
        </span>
        <span v-else class="d-block font-size-10 text-uppercase">
          {{ contactTypeFormat }}
        </span>
        <div v-if="contactType === 'email'">
          <span
            class="d-block font-size-12 font-weight-600"
            :class="{ 'text-color-primary': isPrimary }"
          >
            {{ contactData }}
          </span>
          <span class="d-block text-subdata font-size-12">
            {{ contactSubData }}</span
          >
        </div>
        <div v-else-if="contactType === 'phone'">
          <span
            class="d-block font-size-12 font-weight-600"
            :class="{ 'text-color-primary': isPrimary }"
          >
            {{ phoneFormatter(contactData) }}
          </span>
          <span class="d-block text-subdata font-size-12">
            {{ contactSubData }}</span
          >
        </div>
        <div v-else>
          <span
            class="d-block font-size-12 font-weight-600"
            :class="{ 'text-color-primary': isPrimary }"
          >
            {{ contactData }}
          </span>
          <span class="d-block text-subdata font-size-12">
            {{ contactSubData }}</span
          >
        </div>
      </div>
      <div
        v-if="isShowVerticalIconMenu || isContactTypeLineToken"
        class="icon-position"
      >
        <b-dropdown
          no-caret
          right
          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
          text="Dark"
          variant="flat-dark"
          size="sm"
          class="node__dropdown"
        >
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon"></feather-icon>
          </template>
          <b-dropdown-item
            v-if="!isContactTypeLineToken"
            @click="clickMakePrimary"
          >
            <div class="d-flex align-items-center">
              <feather-icon icon="AwardIcon" class="mr-1"></feather-icon>
              <span class="custom-padding-top">Make Primary</span>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider v-if="!isContactTypeLineToken" />
          <b-dropdown-item @click="clickDelete">
            <div class="d-flex align-items-center text-color-danger">
              <feather-icon icon="Trash2Icon" class="mr-1"></feather-icon>
              <span class="custom-padding-top">Delete</span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive"
import { BDropdown, BDropdownItem, BDropdownDivider } from "bootstrap-vue"

import AtomButton from "./AtomButton.vue"
import AtomCustomAvatar from "./AtomCustomAvatar.vue"
export default {
  name: "AtomContactDetail",

  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    AtomButton,
    AtomCustomAvatar,
  },

  directives: {
    Ripple,
  },

  props: {
    contactId: {
      type: String,
      required: false,
    },
    contactType: {
      type: String,
      required: true,
      validator: (value) => {
        return ["phone", "email", "lineToken"].includes(value)
      },
    },
    contactData: {
      type: String,
      required: true,
    },
    contactSubData: {
      type: String,
      required: false,
    },
    isPrimary: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowMoreIconMenu: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ["onClickMakePrimary", "onClickDelete"],

  computed: {
    avatarIcon() {
      switch (this.contactType) {
        case "phone":
          return "PhoneIcon"
        case "email":
          return "MailIcon"
        case "lineToken":
          return "MessageCircleIcon"
      }
    },
    avatarVariant() {
      switch (this.isPrimary) {
        case true:
          return "light-primary"
        case false:
          return "light-secondary"
      }
    },
    isShowVerticalIconMenu() {
      return this.isShowMoreIconMenu && !this.isPrimary
    },
    isContactTypeLineToken() {
      return this.contactType === "lineToken"
    },
    contactTypeFormat() {
      switch (this.contactType) {
        case "phone":
          return "phone"
        case "email":
          return "email"
        case "lineToken":
          return "line token"
      }
    },
  },

  methods: {
    clickMakePrimary() {
      this.$emit("onClickMakePrimary", this.contactId, this.contactData)
    },
    clickDelete() {
      this.$emit("onClickDelete", this.contactId, this.contactData)
    },
    phoneFormatter(phone) {
      let secondDigit = phone[1]
      if (["6", "8", "9"].includes(secondDigit) && phone.length === 10) {
        let splitPhone = phone
          .replace(/\D/g, "")
          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
        return `${splitPhone[1]} ${splitPhone[2]} ${splitPhone[3]}`
      } else if (["2"].includes(secondDigit) && phone.length === 9) {
        let splitPhone = phone
          .replace(/\D/g, "")
          .match(/(\d{0,2})(\d{0,3})(\d{0,4})/)
        return `${splitPhone[1]} ${splitPhone[2]} ${splitPhone[3]}`
      } else {
        return phone
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-padding-left-8 {
  padding-left: 8px;
}

.justify-self-end {
  justify-self: end;
}

.custom-gap {
  gap: 10px;
}

.icon-position {
  position: absolute;
  right: 0px;
}

.text-subdata {
  margin-top: 2px;
  padding-right: 100px;
  line-height: 1.75;
}
</style>
